<section>
  <div class="top">
    <div>
      <div
        *ngIf="this.currentUser && this.currentUser.isSuperUser"
        class="status"
      >
        <span><b>Now Playing Preview URL: </b></span
        ><input type="text" [value]="videoUrl || 'Loading...'" />
      </div>
      <div class="buttons-container">
        <back-button
          [title]="'Scheduler'"
          [url]="'/scheduler/calendar'"
        ></back-button>

        <div>
          <button
            class="retranscodeButton"
            *ngIf="
              this.currentUser &&
              this.currentUser.isSuperUser &&
              !!media &&
              !media.recording &&
              media.mediaTypeValue === 0
            "
            (click)="retrancodeCurrentMedia()"
          >
            Retranscode
          </button>
          <div
            class="dropdown download"
            *ngIf="
              !!media
                ? media.mediaLinkedType !== 3 &&
                  showDownloadButton &&
                  this.currentUser.hasDownloadMediaPermission
                : false
            "
          >
            <button
              class="downloadButton"
              (click)="openDropdown(downloadDropdown)"
            >
              Download
            </button>
            <span
              class="downloadSvg"
              inlineSVG="/assets/icons/ichannel_Plus-icon.svg"
            ></span>
            <div #downloadDropdown class="dropdown-options">
              <a
                (click)="DownloadFileChosen(1)"
                *ngIf="media && !media.OriginalMediaIsDeleted"
                >Original File</a
              >
              <a (click)="DownloadFileChosen(2)">Transcoded</a>
              <a (click)="DownloadFileChosen(3)">Preview</a>
            </div>
          </div>
          <div
            class="dropdown download"
            *ngIf="
              !!media
                ? media.mediaLinkedType !== 3 &&
                  showPreviewButton &&
                  this.currentUser.isSuperUser
                : false
            "
          >
            <button
              class="downloadButton"
              (click)="openDropdown(playTranscodedDropdown)"
            >
              Choose Video File To Preview
            </button>
            <span
              class="downloadSvg"
              inlineSVG="/assets/icons/ichannel_Plus-icon.svg"
            ></span>
            <div #playTranscodedDropdown class="dropdown-options">
              <!--<a *ngIf="media && !media.recording" (click)="DownloadFileChosen(7)">Transcoded (Wasabi-London)</a>-->
              <!--<a *ngIf="media && !media.recording" (click)="DownloadFileChosen(4)">Transcoded (OVH-GRA)</a>-->

              <a
                *ngIf="media && media.recording"
                (click)="DownloadFileChosen(4)"
                >Transcoded (High-Res)</a
              >
              <!--<a
                *ngIf="media && !media.recording"
                (click)="DownloadFileChosen(5)"
                >Transcoded (Wasabi)</a
              >-->
              <a
                *ngIf="media && !media.recording"
                (click)="DownloadFileChosen(8)"
                >Transcoded (BackBlaze)</a
              >
              <a
                *ngIf="media && !media.recording"
                (click)="DownloadFileChosen(9)"
                >Transcoded (iDrive)</a
              >
              <a *ngIf="media" (click)="DownloadFileChosen(6)">Preview</a>
            </div>
          </div>
        </div>

        <div
          class="upload-media-tc-contract-button"
          *ngIf="!!media ? media.mediaLinkedType === 3 : false"
        >
          <input
            id="uploadMediaInput"
            class="upload-media-tc-contract-input"
            type="file"
            [(ngModel)]="newItem"
            (change)="onUploadFileChange($event)"
            multiple
            accept="image/*,video/*,audio/*,application/mxf,
                                   .aaf,.3gp,.gif,.asf,.avchd,.avi,.bik,.cam,.collab,.dat,.dsh,.dvr-ms,.flv,.m1v,
                                   .m2v,.fla,.flr,.sol,.m4v,.mkv,.wrap,.mng,.mov,.mpeg,.mpg,.mpe,.mp4,.mxf,.roq,
                                   .nsv,.ogg,.rm,.svi,.smi,.smk,.swf,.wmv,.wtv,.yuv,.webm,
                                   .jpg,.jpeg,.exif,.tiff,.tif,.gif,.bmp,.png,.ppm,.pgm,.pbm,.pnm,.webp,.rgbe,
                                   .heif,.bpg,.ico,.xisf,
                                   .3gp, .aa, .aac, .aax, .act, .aiff, .amr, .ape, .au, .awb,
                                   .dct, .dss, .dvf, .flac, .gsm, .iklax, .ivs, .m4a, .m4b, .m4p, .mmf,
                                   .mp3, .mpc, .msv, .oga, .mogg, .opus, .ra, .rm, .raw, .sln, .tta,
                                   .vox, .wav, .wma, .wv"
          />
          <label
            class="upload-media-input-label"
            for="uploadMediaInput"
          ></label>
          <button class="downloadButton">Upload</button>
          <div
            class="downloadSvg downloadSvg-contract"
            inlineSVG="/assets/icons/ichannel_Plus-icon.svg"
          ></div>
        </div>
      </div>
      <h2>
        {{
          media
            ? media.name
              ? media.name
              : media.userFilename
                ? media.userFilename
                : ""
            : ""
        }}
      </h2>
      <div *ngIf="!!media ? media.mediaLinkedType !== 3 : false" class="info">
        <i>
          <span>{{ formatDurationAndFps() }}</span>
        </i>
        <label class="info-header"
          >CREATED DATE:
          <label class="info-header-content">{{
            media ? media.uploadTime.format("MMMM D, YYYY HH:mm") : ""
          }}</label></label
        >
        <label class="info-header"
          >TRANSCODED DATE:
          <label class="info-header-content">{{
            media ? media.analyzedTime.format("MMMM D, YYYY HH:mm") : ""
          }}</label>
        </label>
        <label class="info-header"
          >FILE TYPE:
          <label class="info-header-content">{{
            media ? getFileType(media) : ""
          }}</label></label
        >
        <label class="info-header"
          >RESOLUTION:
          <label class="info-header-content"
            >{{ media ? media.contentWidth : "" }}X{{
              media ? media.contentHeight : ""
            }}</label
          ></label
        >
        <label class="info-header"
          >ASPECT RATIO:
          <label class="info-header-content">{{
            calculateAspectRatio()
          }}</label></label
        >
        <label class="info-header"
          >START TIMECODE:
          <label class="info-header-content">{{
            media ? media.formatStartTime(channelFramerate) : ""
          }}</label></label
        >
        <label class="info-header"
          >LUFS(dB):
          <label class="info-header-content">{{
            media ? media.formattedLufs : ""
          }}</label></label
        >
      </div>
      <div
        *ngIf="!!media ? media.mediaLinkedType === 3 : false"
        class="contract-info"
      >
        <div class="contract-duration-container">
          <label class="contract-edit-duration">ESTIMATED DURATION:</label>
          <div
            class="contract-duration"
            #contractDurationElement
            [attr.contenteditable]="false"
            (keypress)="onContractDurationEnterClicked($event)"
            (blur)="editContractDuration($event)"
            (click)="onContractDurationClick($event)"
          >
            {{ formatContractDurationAndFps(media.contentDuration) }}
          </div>
          <div class="contract-edit-icon"></div>
        </div>
      </div>
    </div>
    <div class="video-container-container">
      <video-container
        [ngStyle]="calculateQccVideoSize()"
        [media]="media"
        [subtitles]="media?.subtitles"
        [closedCaptions]="media?.closedCaptions"
        [audio]="media?.audioFiles"
        [posterUrl]="media?.contentSnapshotUrl"
        [videoUrl]="videoUrl"
        [subtitleOffsetMs]="qcPreviewSubtitleOffsetMs"
        [seekPlayerToTime]="seekPlayerToTime"
        [framerate]="!!media ? media.contentFps : 0"
        (currentTimeMsChange)="
          mediaSegmentsViewModel?.setQcPreviewCurrentTimeMs($event)
        "
        [showTimecode]="true"
      ></video-container>
      <div
        class="crop-mark-box"
        *ngIf="
          media && media.cropSettings && media.cropSettings.isNoCrop() === false
        "
        [ngStyle]="markBoxStyle"
      >
        <div></div>
      </div>
    </div>
  </div>
  <div class="bottom">
    <tabs
      *ngIf="tabs"
      [backgroundColor]="'#f1f3f4'"
      [tabs]="tabs"
      [media]="media"
      [mediaSegmentsViewModel]="mediaSegmentsViewModel"
      [activeTab]="selectedTabIndex"
      [markBoxStyle]="markBoxStyle"
      [floatingMediaPositionRectangleVM]="floatingMediaPositionVM"
      [videoSize]="getQccVideoSize()"
      [media-qc-workflow-objectives-changed]="mediaQCWorkflowObjectivesChanged"
      (output)="onTabsOutput($event)"
    ></tabs>
  </div>
</section>
